'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';

const LOCATIONS_PATH = '/locations';

interface LocationLinkProps {
  slug?: string;
  children: ReactNode;
}

const LocationLink = ({ slug, children }: LocationLinkProps) => {
  const pathname = usePathname();
  const href = slug ? `${LOCATIONS_PATH}#${slug}` : LOCATIONS_PATH;

  return (
    <Link
      href={href}
      className='hover:underline'
      onNavigate={event => {
        if (pathname !== LOCATIONS_PATH) return;

        event.preventDefault();
        window.history.pushState(null, '', href);
        window.dispatchEvent(new HashChangeEvent('hashchange'));
      }}
    >
      {children}
    </Link>
  );
};

export default LocationLink;
